import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPostDownload } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";


export const ExportEntitiesAction = createAsyncThunk(
    "exportEntities", async (arg, { rejectWithValue }) => {
        try {
            const resposnse = await doPostDownload(urls?.getEntitiesData, arg);
            return resposnse;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const ExportEntitiesActionSlice = createSlice({
    name: "exportEntities",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        exportEntitiesActionReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        }
    },
    extraReducers: {
        [ExportEntitiesAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.error = false;
            state.data = payload;

        },
        [ExportEntitiesAction.pending]: (state) => {
            state.isLoading = true;
            state.success = false;
            state.error = false;
        },
        [ExportEntitiesAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.success = false;
            state.error = payload;
        },
    }
})

export const { exportEntitiesActionReset } = ExportEntitiesActionSlice.actions;